import { createSelector } from "reselect";

const DEFAULT_TABLE_ROWS_PER_PAGE = 10;

const selectGlobal = (state) => state.global;

const selectDarkMode = () => createSelector(selectGlobal, (globalState) => globalState.darkMode);

const selectActiveNotifications = () =>
  createSelector(selectGlobal, (globalState) => globalState.activeNotifications);

const selectCreatedTableRowsIds = () =>
  createSelector(selectGlobal, (globalState) => globalState.createdTableRowsIds);

const selectSelectedTableRowsIds = () =>
  createSelector(selectGlobal, (globalState) => globalState.selectedTableRowsIds);

const selectTableRowsPerPage = (tableKey) =>
  createSelector(
    selectGlobal,
    (globalState) =>
      globalState.tableRowsPerPage[tableKey ?? "default"] ?? DEFAULT_TABLE_ROWS_PER_PAGE
  );

export {
  selectDarkMode,
  selectTableRowsPerPage,
  selectActiveNotifications,
  selectCreatedTableRowsIds,
  selectSelectedTableRowsIds
};
